/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createWebhusetOrderApiFeaturesCatalogTldGetResponseFromDiscriminatorValue, type WebhusetOrderApiFeaturesCatalogTldGetResponse } from '../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /catalog/tld
 */
export interface TldRequestBuilder extends BaseRequestBuilder<TldRequestBuilder> {
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<WebhusetOrderApiFeaturesCatalogTldGetResponse>}
     */
     get(requestConfiguration?: RequestConfiguration<TldRequestBuilderGetQueryParameters> | undefined) : Promise<WebhusetOrderApiFeaturesCatalogTldGetResponse | undefined>;
    /**
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<TldRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
export interface TldRequestBuilderGetQueryParameters {
    coupon?: string;
}
/**
 * Uri template for the request builder.
 */
export const TldRequestBuilderUriTemplate = "{+baseurl}/catalog/tld{?coupon*}";
/**
 * Metadata for all the requests in the request builder.
 */
export const TldRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: TldRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        adapterMethodName: "send",
        responseBodyFactory:  createWebhusetOrderApiFeaturesCatalogTldGetResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
